/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {Text} from '@chakra-ui/react';
import {StructuredText} from 'react-datocms';
import {isParagraph} from 'datocms-structured-text-utils';
import {
  ProductModelHeroContentField,
  ProductModelHeroTitleField,
} from '../../graphql/datocms-generated';

export const HeroBodyCopy = ({
  text,
}: {
  text: ProductModelHeroContentField | undefined;
}) => (
  <StructuredText
    data={text?.value}
    customRules={[
      {
        appliable: isParagraph,
        apply: ({children, key}) =>
          children ? (
            <Text key={key} textStyle="body3_1c" mt={6}>
              {children}
            </Text>
          ) : null,
      },
    ]}
  />
);

export const HeroTitleCopy = ({
  text,
}: {
  text: ProductModelHeroTitleField | undefined;
}) => (
  <StructuredText
    data={text?.value}
    customRules={[
      {
        appliable: isParagraph,
        apply: ({children, key}) =>
          children ? (
            <Text
              as="h1"
              key={key}
              fontSize={{base: '32px', md: '40px'}}
              textStyle="h2_1c"
            >
              {children}
            </Text>
          ) : null,
      },
    ]}
  />
);
